<!--
todo : implementer les boutons "ajouter un droit" et "trash"
      utiliser l'idCompany qui vient de la page CompanyPage.value


-->

<template>
  <page-outline :title="$t('administration.company_dtls')">
    <template slot="pageContent">
      <b-row v-if="this.$engine.firstOn().company.redirection === '0'" class="pb-3 mx-0">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <template v-if="CompaniesList.length > 0" >
          <div class="title-label-blue w-200px">{{$t('administration.company_info')}}</div>
          <table class="table">
            <tbody>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.company_id') }}
                </th>
                <td class="text-center w-50">
                  {{ CompaniesList[0].account.identifier }}
                </td>
              </tr>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.company_name') }}
                </th>
                <td class="text-center w-50">
                  {{ CompaniesList[0].account.name }}
                </td>
              </tr>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.company_email') }}
                </th>
                <td class="text-center w-50">
                  {{ CompaniesList[0].account.email_reference }}
                </td>
              </tr>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.active') }}
                </th>
                <td class="text-center w-50">
                  <i v-if="CompaniesList[0].active == 0" class="fa-duotone fa-xmark btn-icon text-danger p-0"></i>
                  <i v-if="CompaniesList[0].active == 2" class="fa-duotone fa-check btn btn-icon text-success p-0"></i>
                  <i v-if="CompaniesList[0].active == 1" class="fa-duotone fa-warning btn btn-icon text-warning p-0"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </template>

        <br>

        <!-- COMPANY USERS -->
        <div class="title-label-blue w-200px">{{$t('administration.company_users')}}</div>
        <b-table hover fixed responsive
        ref="userList"
        class="mt-3"
        :fields="userListFields"
        :items="CompaniesList[0].users"
        :selectable="CompaniesList[0].users.length > 0"
        :sort-by.sync="sortBy"
        :empty-text="$t('errors.No_results_found')"
        @row-selected="seeDetailsUser">
          <template #cell(login)="data">
            <div class="cursor text-ellipsis">{{ data.value }}</div>
          </template>
          <template #cell(name)="data">
            <div v-if="!data.value">-</div>
            <div v-else class="cursor text-ellipsis">{{ data.value }}</div>
          </template>
        </b-table>
        <b-row v-if="canAddUser" class="no-gutter d-flex justify-content-end">
          <b-button variant="primary"
            @click="addUser">
            <i class="fa-light fa-plus"></i>
            <span>{{$t('administration.user_add')}}</span>
          </b-button>
        </b-row>

        <br>

        <!-- COMPANY PROFILES -->
        <div class="title-label-blue w-200px">{{$t('administration.company_prfls')}}</div>
        <table class="table">
          <thead>
            <th class="text-center w-200px">
              {{ $t('administration.label') }}
            </th>
          </thead>
          <tbody>
            <template v-if="CompaniesList.length > 0">
              <tr v-for="result in filteredProfiles">
                <td class="text-center" :title="result.libelle">{{ result.libelle }}</td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="noResult">
                {{ $t('common.no_result') }}
              </td>
            </tr>
          </tbody>
        </table>

        <br>

        <!-- COMPANY RIGHTS -->
        <div class="title-label-blue w-200px">{{$t('administration.company_rights')}}</div>
        <table class="table text-center">
          <thead>
            <th>
              {{$t('administration.right_list')}}
            </th>
          </thead>
          <tbody>
            <template v-if="CompaniesList.length > 0">
              <tr v-for="result in CompaniesList[0].rights">
                <td :title="$t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result)">
                  {{ $t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result) }}
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="noResult">
                {{ $t('common.no_result') }}
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <b-row class="justify-content-end no-gutters" v-if="canCompanyDelete ||canCompanyEdit">
          <div v-if="canCompanyDelete" class="deleteUser">
            <b-button class="btn btn-sm mr-3" variant="primary" @click="activateCompanyDelete(CompaniesList[0].idCompany)">
              <i class="fa-light fa-trash"></i>  {{ $t('administration.company_delete') }}
            </b-button>
          </div>
          <div v-if="canCompanyEdit" class="editUser">
            <b-button class="btn btn-sm" variant="primary"  @click="activateCompanyEdit(CompaniesList[0].idCompany)">
              <i class="fa-light fa-pencil"></i>  {{ $t('administration.company_edit') }}
            </b-button>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
// import moment from 'moment-timezone'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, reloadPage2} from './../../helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'CompanyDetails',
  components: {
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canAddUser () {
      return this.$engine.firstOn().rights.rightIs('usercompany_add', true)
    },
    canCompanyDelete () {
      return this.$engine.firstOn().rights.rightIs('company_delete', true)
    },
    canCompanyEdit () {
      return this.$engine.firstOn().rights.rightIs('company_edit', true)
    },
    filteredProfiles () {
      if (this.CompaniesList.length) {
        return this.CompaniesList[0].profiles.filter(elem => {
          return !elem.libelle.includes('Norm_')
        })
      }
      return []
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return 'Details de l\'entreprise'
    },
    userListFields () {
      return [
        { key: 'login', isActive: false, label: this.$i18n.t('administration.login'), class: 'w-50', thClass: 'text-left pl-4', tdClass: 'pl-4'},
        { key: 'name', label: this.$i18n.t('administration.user_name'), class: 'w-50', thClass: 'text-left pl-4', tdClass: 'pl-4'}
      ]
    }
  },
  props: ['idCompany'],
  data () {
    return {
      activateSpinner: false,
      CompaniesList: [],
      profiles: [],
      redirection: this.$engine.firstOn().company.redirection,
      returnUrl: '/company/',
      sortBy: 'login'
    }
  },
  created () {
    this.returnUrl = this.returnUrl + this.redirection
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'entreprise',
      returnUrl: ''
    })

    this.$engine.firstOn().settings.set({msgDirection: this.direction})
    this.atStart(this.idCompany) // modif a check
    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')

  },
  methods: {
    addUser () {
      let that = this
      this.$engine.firstOn().company.profiles = that.CompaniesList[0].profiles
      loadPage(that, {url: '/addusercompany/' + this.idCompany})
    },
    atStart (val = 1) {
      let that = this
      that.pageCounter = 0
      that.activateSpinner = true
      // this.$engine.firstOn().company.idCompany = val
      // that.$engine.firstOn().company.idCompany = val
      that.CompaniesList = []
      let filterConditions = that.$engine.firstOn().company.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.firstOn().company.getCompany(
        val,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.company) {
          resp.data.company.idCompany = val
          resp.data.company.identifier = resp.data.company.account.identifier
          resp.data.company.name = resp.data.company.account.name
          resp.data.company.email_reference = resp.data.company.account.email_reference
          resp.data.company.active = resp.data.company.account.active
          resp.data.company.rights = resp.data.company.rights
          resp.data.company.profiles.forEach(item => {
            item.id_rights_profile = item.id_rights_profile
            item.libelle = item.libelle
          })
          resp.data.company.users.forEach(item => {
            item.id_user_account = item.id_user_account
            item.login = item.login
          })
          requests = resp.data.company
          that.CompaniesList.push(requests)
          that.CompaniesList[0].profiles.sort((a, b) => {
            return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
          })
          that.$f7.pullToRefreshDone()
          that.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        // that.CompaniesList.push(requests)
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    activateCompanyEdit (ressource) {
      let that = this
      this.$engine.firstOn().company.profiles = that.CompaniesList[0].profiles
      loadPage(this, {url: '/editcompany/' + ressource})
    },
    activateCompanyDelete (ressource) {
      let that = this
      if (ressource === this.$engine.firstOn().user.get().id) {
        that.$f7.modal({
          title: this.$i18n.t('Impossible de supprimer votre propre entreprise'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      } else {
        this.$f7.modal({
          title: 'Voulez vous vraiment supprimer cette entreprise',
          buttons: [
            {
              text: this.$t('creation_forms.vldt'),
              onClick: function () {
                that.$engine.firstOn().company.deleteCompany(ressource)
                .then(resp => {
                  that.$f7.alert('', that.$t('Entreprise supprimé'))
                  loadPage(that, {url: '/company/' + that.redirection})
                })
              }
            },
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      }
    },
    refreshProfileList () {
    },
    seeDetailsUser (user) {
      this.$refs.userList.clearSelected()
      if (user.length) {
        this.$engine.firstOn().company.profiles = this.CompaniesList[0].profiles
        loadPage(this, {url: '/detailusercompany/' + user[0].id_user_account + '/' + this.idCompany})
      }
    },
    updateInbox (requests, noAttach) {
    }
  }
}
</script>
